import React from 'react'
import styled from 'styled-components'

const StyledIcon = styled.svg`
  color: ${({ color, theme }) => theme.colors[color]};
  height: ${p => p.size};
  width: ${p => p.size};
  display: inline-block;
  margin-top: ${({ checklist }) => (checklist ? '2px' : '')};
  transform: ${({ rotation }) => (rotation ? `rotateZ(${rotation}deg)` : '')};
`

const sizes = {
  tiny: '0.8rem',
  small: '1rem',
  medium: '1.25rem',
  large: '1.8rem',
  huge: '3rem',
}

const Icon = ({ size, type, ...otherProps }) => {
  const mappedSize = sizes[size] || sizes.medium

  return (
    <StyledIcon size={mappedSize} {...otherProps}>
      <use xlinkHref={`#${type || 'checkmark'}`} />
    </StyledIcon>
  )
}

export default Icon
